import { AdvancedImage } from "@cloudinary/react";
import DOMPurify from "dompurify";
import { Button } from "primereact/button";
import { Checkbox } from "primereact/checkbox";
import { Dialog } from "primereact/dialog";
import { Dropdown } from "primereact/dropdown";
import { Editor } from "primereact/editor";
import { FileUpload } from "primereact/fileupload";
import { InputNumber } from "primereact/inputnumber";
import { InputText } from "primereact/inputtext";
import { Toast } from "primereact/toast";
import { Tooltip } from "primereact/tooltip";
import { useCallback, useEffect, useRef, useState } from "react";
import ReactQuill from "react-quill";
import { useToggle } from "../../../../hooks/useToggle";
import localeText from "../../../../locale";
import ProductService from "../../../../service/ProductService";
import { cloudinaryInstance } from "../../../../utilities/Cloudinary/cloudinaryInstance";
import handleLocale from "../../../../utilities/LocaleSwitch";
import {
  CUSTOMER_MAX_PERCENT_CASHBACK,
  CUSTOMER_MIN_PERCENT_CASHBACK,
  MANAGER_MAX_PERCENT_CASHBACK,
  MANAGER_MIN_PERCENT_CASHBACK,
  PARTNER_MAX_PERCENT_CASHBACK,
  PARTNER_MIN_PERCENT_CASHBACK,
  PLATFORM_PRODUCT_FEE,
  SELLER_MAX_PERCENT_CASHBACK,
  SELLER_MIN_PERCENT_CASHBACK,
} from "../../../../utilities/constants";
import { formatPrice } from "../../../../utilities/formatPrice";
import { locale } from "../../../../utilities/locale/locale";
import "./NewProduct.css";
import HeaderEditorTemplate from "./components/HeaderEditorTemplate/HeaderEditorTemplate";
import { removelocalStorageToken } from "../../../../utilities/sessionStorage/token";
import { removelocalStorageUsername } from "../../../../utilities/sessionStorage/username";
import { useHistory } from "react-router-dom";
import useUploadFiles from "../../../../hooks/useUploadFiles";
import { RadioButton } from "primereact/radiobutton";
import { weightInputs, freightInputs, listTypeProduct } from "./inputs";
import Loading from "../../../../components/Loading/Loading";
import CostCalculator from "./components/CostCalculator";
import { useToastContext } from "../../../../contexts/ToastContext/ToastContext";
import GetInfoService from "../../../../service/GetInfoService";
import { Link } from "react-router-dom";
import IospediscoService from "../../../../service/iospedisco";
import useGetUserExtrabonus from "../../../../hooks/useGetUserExtrabonus";
import GetUserInfoService from "../../../../service/GetUserInfoService";
import { Tag } from "primereact/tag";
import Webcam from "react-webcam";

const videoConstraints = {
  width: 550,
  height: 550,
  facingMode: "user",
};

const errorsNumbersForCashback = {
  Partner: 500070,
  Manager: 500071,
  Seller: 500168,
  Customer: 500195,
};

const NewProduct = (props) => {
  const { showErrorToast } = useToastContext();

  const downloadableId = parseInt(process.env.REACT_APP_DOWNLOADABLE_ID);
  const audioId = parseInt(process.env.REACT_APP_AUDIO_ID);
  const videoId = parseInt(process.env.REACT_APP_VIDEO_ID);
  const imageId_ = parseInt(process.env.REACT_APP_IMAGE_ID);
  const documentId = parseInt(process.env.REACT_APP_DOCUMENT_ID);
  const [imageSrc, setImageSrc] = useState(null);

  const webcamRef = useRef(null);
  const capture = useCallback(() => {
    const imageSrc = webcamRef.current.getScreenshot();
    setImageSrc(imageSrc);
  }, [webcamRef]);

  const productService = new ProductService();
  const toast = useRef(null);
  const { uploadAudio, uploadFile } = useUploadFiles();

  const [categories, setCategories] = useState([]);
  const [specificCategories, setSpecificCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [subcategories, setSubcategories] = useState([]);
  const [selectedSubcategory, setSelectedSubcategory] = useState(null);
  const [currencyCode, setCurrencyCode] = useState("USD");
  const [localeISO, setLocaleISO] = useState("en-US");
  const [percentMin, setPercentMin] = useState(0);
  const [percentMax, setPercentMax] = useState(0);
  const [loadingCategories, setLoadingCategories] = useState(true);
  const [loadingPermissionForCustomer, setLoadingPermissionForCustomer] = useState(false);
  const [customerHasPermission, setCustomerHasPermission] = useState(false);
  const {
    value: valueTakePicture,
    setAsFalse: setFalseTakePicture,
    setAsTrue: setTrueTakePicture,
  } = useToggle();

  // Product info
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [priceUnique, setPriceUnique] = useState(0);
  const [promotionalPriceUnique, setPromotionalPriceUnique] = useState(0);
  const [percentExtraCoin, setPercentExtracoin] = useState(null);
  const [productState, setProductState] = useState(null);
  const [productCondition, setProductCondition] = useState(null);
  const [images, setImages] = useState(null);
  const [product, setProduct] = useState(null);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [brand, setBrand] = useState(null);
  const [brands, setBrands] = useState([]);
  const [type, setType] = useState(null);
  const [types, setTypes] = useState([]);
  const [gender, setGender] = useState(null);
  const [genders, setGenders] = useState([]);
  const [model, setModel] = useState("");
  const [hasDiscount, setHasDiscount] = useState(false);
  const [percentComissionByShare, setPercentComissionByShare] = useState(0);
  const [hasComissionByShare, setHasComissionByShare] = useState(false);
  const [loadingRegister, setLoadingRegister] = useState(false);
  const [loadingRegisterPublish, setLoadingRegisterPublish] = useState(false);
  const [stock, setStock] = useState(0);
  const [downloadType, setDownloadType] = useState("");
  const [downloadableProduct, setDownloadableProduct] = useState(null);
  const [sampleProduct, setSampleProduct] = useState(null);
  const [height, setHeight] = useState(0);
  const [width, setWidth] = useState(0);
  const [length, setLength] = useState(0);
  const [weight, setWeight] = useState(0);
  const fileUploadRef = useRef(null);
  const fileUploadDownloadable = useRef(null);
  const fileUploadSample = useRef(null);
  const [selectedTypeProduct, setSelectedTypeProduct] = useState(0); // 1 === product, 2 === service, 3 === downloadable
  const [freight, setFreight] = useState(0);
  const [isLoadingPostalCode, setIsLoadingPostalCode] = useState(false);
  const [postalCode, setPostalCode] = useState("");

  // Technical Info
  const [techInfoKey1, setTechInfoKey1] = useState("");
  const [techInfoValue1, setTechInfoValue1] = useState("");
  const [techInfoKey2, setTechInfoKey2] = useState("");
  const [techInfoValue2, setTechInfoValue2] = useState("");
  const [techInfoKey3, setTechInfoKey3] = useState("");
  const [techInfoValue3, setTechInfoValue3] = useState("");
  const [techInfoKey4, setTechInfoKey4] = useState("");
  const [techInfoValue4, setTechInfoValue4] = useState("");
  const [techInfoKey5, setTechInfoKey5] = useState("");
  const [techInfoValue5, setTechInfoValue5] = useState("");

  const { isLoading: isLoadinguseUserExtrabonus, userExtrabonus } = useGetUserExtrabonus({
    onError: ({ code }) => showErrorToast({ code }),
    typeUser: props.plan,
  });

  const {
    value: isVisibleNotifyModal,
    setAsFalse: setNotVisibleNotifyModal,
    setAsTrue: setVisibleNotifyModal,
  } = useToggle();

  const {
    value: isVisibleCostCalculator,
    setAsFalse: setNotVisibleCostCalculator,
    setAsTrue: setVisibleCostCalculator,
  } = useToggle();

  const [shippingIsAvailable, setShippingIsAvailable] = useState(true);

  const [isLoadingStore, setLoadingStore] = useState(true);
  const [canPublish, setCanPublish] = useState(false);

  const {
    setAsFalse: setNotVisibleAdressWarn,
    setAsTrue: setVisibleAdressWarn,
    value: isVisibleAdressWarn,
  } = useToggle();

  const Navigate = useHistory();

  const productStates = [
    { label: localeText("new"), value: "NEW" },
    { label: localeText("used"), value: "USED" },
  ];

  const productConditions = [
    { label: localeText("labeled"), value: "LABELED" },
    { label: localeText("notLabeled"), value: "NOTLABELED" },
    { label: localeText("excellent"), value: "EXCELLENT" },
    { label: localeText("good"), value: "GOOD" },
    { label: localeText("discrete"), value: "DISCRETE" },
  ];

  const handleHideModalCostCalculator = () => {
    // if (isVisibleCostCalculator) return; tem q ser uma requisição
    setNotVisibleCostCalculator();
  };

  // Paginator
  const [page, setPage] = useState(0);

  const uploadOptions = {
    className: "hidden",
  };

  const hasPermissionRoles =
    props.plan === "Partner" ||
    props.plan === "Manager" ||
    props.plan === "Seller" ||
    props.plan === "Customer";

  useEffect(() => {
    let cancel = false;

    async function fetchData() {
      try {
        if (!hasPermissionRoles) {
          setLoadingCategories(false);
          return;
        }
        setLoadingCategories(true);

        const resCategories = await productService.getCategories();
        if (cancel) return;

        setCurrencyCode(props.currency);

        setLocaleISO(handleLocale(locale));

        switch (props.plan) {
          case "Customer":
            setPercentExtracoin(null);
            setPercentMin(CUSTOMER_MIN_PERCENT_CASHBACK);
            setPercentMax(CUSTOMER_MAX_PERCENT_CASHBACK);
            break;
          case "Partner":
            setPercentExtracoin(null);
            setPercentMin(PARTNER_MIN_PERCENT_CASHBACK);
            setPercentMax(PARTNER_MAX_PERCENT_CASHBACK);
            break;
          case "Manager":
            setPercentExtracoin(null);
            setPercentMin(MANAGER_MIN_PERCENT_CASHBACK);
            setPercentMax(MANAGER_MAX_PERCENT_CASHBACK);
            break;
          case "Seller":
            setPercentExtracoin(null);
            setPercentMin(SELLER_MIN_PERCENT_CASHBACK);
            setPercentMax(SELLER_MAX_PERCENT_CASHBACK);
            break;
          default:
            break;
        }

        if (resCategories.messageCode !== 200001) {
          showErrorToast({ code: resCategories.messageCode });
          setLoadingCategories(false);
        } else {
          setCategories(resCategories.result);
          setLoadingCategories(false);
        }
      } catch (e) {
        setLoadingCategories(false);
        console.log(e);
      }
    }

    fetchData();

    return () => {
      cancel = true;
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  async function uploadImages(image, publish) {
    try {
      const res = await productService.postUploadImage(
        localStorage.getItem("__extraconomy_token"),
        image
      );

      if (res.messageCode !== 200000) {
        showErrorToast({ code: res.messageCode });
        publish ? setLoadingRegisterPublish(false) : setLoadingRegister(false);
        return false;
      } else {
        return res.result;
      }
    } catch (e) {
      if (e.status === 401) {
        removelocalStorageToken();
        removelocalStorageUsername();
        Navigate.push("/login");
      } else if (e.status === 500) showErrorToast({ detail: "unexpectedSystemBehaviour" });
      else showErrorToast({ detail: "unexpectedErrorUploadImg" });
    }
  }
  console.log(types);
  useEffect(() => {
    if (selectedSubcategory) {
      setBrands(null);
      setTypes(null);
      setGenders(null);
      setBrand(null);
      setType(null);
      setGender(null);

      if (selectedSubcategory.brands.length > 0) {
        const arrBrands = [];

        selectedSubcategory.brands.forEach((brandObj) => {
          const obj = {
            label: brandObj.description,
            value: brandObj,
          };

          arrBrands.push(obj);
        });

        setBrands(arrBrands);
      }

      if (selectedSubcategory.types.length > 0) {
        const arrTypes = [];

        selectedSubcategory.types.forEach((typeObj) => {
          let labelDescription = "";

          switch (locale) {
            case "it":
              labelDescription = typeObj.descriptionItalian;
              break;
            case "es":
              labelDescription = typeObj.descriptionSpanish;
              break;
            case "pt":
              labelDescription = typeObj.descriptionPortuguese;
              break;
            case "en":
              labelDescription = typeObj.descriptionEnglish;
              break;
            default:
              break;
          }

          if (!labelDescription) labelDescription = typeObj.description;

          const obj = {
            label: labelDescription,
            value: typeObj,
          };

          arrTypes.push(obj);
        });

        setTypes(arrTypes);
      }

      if (selectedSubcategory.genders.length > 0) {
        const arrGenders = [];

        selectedSubcategory.genders.forEach((genderObj) => {
          let genderDescription = "";
          switch (locale) {
            case "en":
              genderDescription = genderObj.descriptionEnglish;
              break;
            case "it":
              genderDescription = genderObj.descriptionItalian;
              break;
            case "pt":
              genderDescription = genderObj.descriptionPortuguese;
              break;
            case "es":
              genderDescription = genderObj.descriptionSpanish;
              break;
            default:
              break;
          }

          const obj = {
            label: genderDescription,
            value: genderObj,
          };

          arrGenders.push(obj);
        });

        setGenders(arrGenders);
      }

      if (selectedCategory.id === downloadableId) {
        if (selectedSubcategory.id === audioId) setDownloadType("AUDIO");
        if (selectedSubcategory.id === videoId) setDownloadType("VIDEO");
        if (selectedSubcategory.id === imageId_) setDownloadType("IMAGE");
        if (selectedSubcategory.id === documentId) setDownloadType("DOCUMENT");
      }

      setPage(3);
    } // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedSubcategory]);

  async function registerProduct(
    published,
    notifyAllUsers = false,
    notifyMyEconomicCircle = false
  ) {
    try {
      if (notifyMyEconomicCircle && userExtrabonus?.balance < 20) {
        showErrorToast({ detail: "insufficientCredits" });
        return;
      }

      if (images?.length > 10) {
        showErrorToast({ detail: "youCanOnlyChooseUpTo5" });
        return;
      }

      if (notifyAllUsers && userExtrabonus?.balance < 50) {
        showErrorToast({ detail: "insufficientCredits" });
        return;
      }
      published ? setLoadingRegisterPublish(true) : setLoadingRegister(true);

      if (images?.length > 0) {
        if (images[0]) product.imageid1 = await uploadImages(images[0], false);
        if (images[1]) product.imageid2 = await uploadImages(images[1], false);
        if (images[2]) product.imageid3 = await uploadImages(images[2], false);
        if (images[3]) product.imageid4 = await uploadImages(images[3], false);
        if (images[4]) product.imageid5 = await uploadImages(images[4], false);
        if (images[5]) product.imageid6 = await uploadImages(images[5], false);
        if (images[6]) product.imageid7 = await uploadImages(images[6], false);
        if (images[7]) product.imageid8 = await uploadImages(images[7], false);
        if (images[8]) product.imageid9 = await uploadImages(images[8], false);
        if (images[9]) product.imageid10 = await uploadImages(images[9], false);
      } else {
        published ? setLoadingRegisterPublish(false) : setLoadingRegister(false);
        showErrorToast({ detail: "pleaseUploadAtLeastOne" });
        return;
      }

      if (selectedCategory.id === downloadableId) {
        if (downloadType === "AUDIO") {
          const urldownload_ = await uploadAudio(downloadableProduct);
          if (!urldownload_) return;
          const urlsample_ = await uploadAudio(sampleProduct);
          if (!urlsample_) return;

          product.urldownload = urldownload_;
          product.urldownloadsample = urlsample_;
          product.cdnType = "S3AWS";
        } else {
          const urldownload_ = await uploadFile(downloadableProduct);
          if (!urldownload_) return;
          const urlsample_ = await uploadFile(sampleProduct);
          if (!urlsample_) return;

          product.urldownload = urldownload_;
          product.urldownloadsample = urlsample_;
        }
      }

      if (published) product.productStatus = "PUBLISHED";
      if (hasComissionByShare) product.percentComissionByShare = percentComissionByShare;

      const res = await productService.postRegisterProduct(
        localStorage.getItem("__extraconomy_token"),
        { ...product, notifyAllUsers, notifyMyEconomicCircle }
      );

      if (res.messageCode !== 200000) {
        showErrorToast({ code: res.messageCode });
        published ? setLoadingRegisterPublish(false) : setLoadingRegister(false);
        if (res.messageCode === 500000) console.log(res);
        return;
      }

      if (res.messageCode === 200000) {
        props.handleRetryGetExtracoinInfo();
      }

      if (res.messageCode === 200000) {
        const resStock = await productService.postSetStockByProduct(
          localStorage.getItem("__extraconomy_token"),
          res.result.id,
          stock,
          localStorage.getItem("__extraconomy_username")
        );

        if (resStock.messageCode !== 200000) {
          showErrorToast({ code: resStock.messageCode });
          if (resStock.messageCode === 500000) console.log(resStock);
          published ? setLoadingRegisterPublish(false) : setLoadingRegister(false);
          return;
        }

        let error = false;

        if (techInfoKey1.length > 0 && techInfoValue1.length > 0) {
          const res1 = await productService.postRegisterTechnicalInfo(
            localStorage.getItem("__extraconomy_token"),
            res.result.id,
            techInfoKey1,
            techInfoValue1,
            localStorage.getItem("__extraconomy_username")
          );
          if (res1.messageCode !== 200000) error = true;
        }
        if (techInfoKey2.length > 0 && techInfoValue2.length > 0) {
          const res2 = await productService.postRegisterTechnicalInfo(
            localStorage.getItem("__extraconomy_token"),
            res.result.id,
            techInfoKey2,
            techInfoValue2,
            localStorage.getItem("__extraconomy_username")
          );
          if (res2.messageCode !== 200000) error = true;
        }
        if (techInfoKey3.length > 0 && techInfoValue3.length > 0) {
          const res3 = await productService.postRegisterTechnicalInfo(
            localStorage.getItem("__extraconomy_token"),
            res.result.id,
            techInfoKey3,
            techInfoValue3,
            localStorage.getItem("__extraconomy_username")
          );
          if (res3.messageCode !== 200000) error = true;
        }
        if (techInfoKey4.length > 0 && techInfoValue4.length > 0) {
          const res4 = await productService.postRegisterTechnicalInfo(
            localStorage.getItem("__extraconomy_token"),
            res.result.id,
            techInfoKey4,
            techInfoValue4,
            localStorage.getItem("__extraconomy_username")
          );
          if (res4.messageCode !== 200000) error = true;
        }
        if (techInfoKey5.length > 0 && techInfoValue5.length > 0) {
          const res5 = await productService.postRegisterTechnicalInfo(
            localStorage.getItem("__extraconomy_token"),
            res.result.id,
            techInfoKey5,
            techInfoValue5,
            localStorage.getItem("__extraconomy_username")
          );
          if (res5.messageCode !== 200000) error = true;
        }

        if (error) {
          showErrorToast({ detail: "errorWhileRegisteringTechnicalInfo" });
          published ? setLoadingRegisterPublish(false) : setLoadingRegister(false);
          return;
        }

        Navigate.push("/products");
      } else {
        showErrorToast({ code: res.messageCode });
        published ? setLoadingRegisterPublish(false) : setLoadingRegister(false);
        return;
      }
    } catch (e) {
      showErrorToast({ detail: "unexpectedErrorRegisterProduct" });
      published ? setLoadingRegisterPublish(false) : setLoadingRegister(false);
      console.log(e);
    }
  }

  const getStatusAdress = () => {
    if (props.userInfo.country !== "IT") {
      setVisibleAdressWarn();
      setShippingIsAvailable(false);
    }
  };

  const setNullProductInfo = () => {
    setTitle("");
    setDescription("");
    setPriceUnique(0);
    setFreight(0);
    setWeight(0);
    setPromotionalPriceUnique(0);
    setPercentExtracoin(null);
    setProductState(null);
    setImages(null);
    setProduct(null);
    setCurrentImageIndex(0);
    setBrand(null);
    setBrands([]);
    setType(null);
    setTypes([]);
    setGender(null);
    setGenders([]);
    setModel("");
    setHasDiscount(false);
    setStock(0);
    setDownloadType("");
    setDownloadableProduct(null);
    setSampleProduct(null);
    setHeight(0);
    setWidth(0);
    setLength(0);
    setWeight(0);
    setProductCondition(null);
    fileUploadRef.current.clear();
  };

  useEffect(() => {
    if (props?.userInfo?.addressStatus && props?.userInfo?.country) getStatusAdress(); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props?.userInfo]);

  const [isLoadingFreight, setIsLoadingFreight] = useState(false);
  const [freightPrice, setFreightPrice] = useState();

  const getInfoService = new GetInfoService();
  const iospediscoService = new IospediscoService();
  const getUserInfoService = new GetUserInfoService();

  const getLocationId = async () => {
    try {
      setIsLoadingFreight(true);
      const res = await iospediscoService.getLocatiobId({
        token: localStorage.getItem("__extraconomy_token"),
        postal_code: postalCode,
        country: "IT",
      });

      const locationResult = res?.locationResponse?.location_results;

      if (locationResult && locationResult[0]?.locations_list[0]?.id_location) {
        const locationId = locationResult[0]?.locations_list[0]?.id_location;
        const compare = await iospediscoService.compare({
          token: localStorage.getItem("__extraconomy_token"),
          id_location: locationId,
          width: width,
          height: height,
          weight: weight,
          depth: length,
          pickup_date: props?.userInfo?.amountDaysToPickUp,
        });

        const freight = compare?.comparisonResponse?.comparison_result;
        if (freight) {
          const freightValue = freight[0]?.comparison_items[0]?.total_amount_tax_excluded;
          if (currencyCode !== "EUR") {
            const resForex = await getInfoService.getForexRate("EUR", currencyCode);
            const resFreight = {
              price: freightValue * resForex.result,
              currency: currencyCode,
            };
            setFreightPrice(resFreight);
          } else {
            setFreightPrice({ price: freightValue, currency: "EUR" });
          }
          setIsLoadingFreight(false);
          return;
        }

        if (
          compare?.comparisonResponseError?.comparison_result[0]?.failure_reasons[0]?.includes(
            "minimum volume is 100 cubic centimeters"
          )
        ) {
          showErrorToast({ detail: "minimunValueError" });
        } else {
          showErrorToast({ code: 500000 });
        }
        setIsLoadingFreight(false);
      } else {
        showErrorToast({ detail: "addValidPostalCode" });
        setIsLoadingFreight(false);
      }
    } catch (e) {
      console.log(e);
      setIsLoadingFreight(false);
    }
  };

  async function checkZipCode(zip) {
    if (zip.length > 0) {
      try {
        const zip_ = zip.replace(/\D+/g, "");
        setIsLoadingPostalCode(true);

        const userCountry = await getInfoService.getUserCountry();
        const res = await getInfoService.getZipCodeInfo(zip_, userCountry);

        if (Array.isArray(res.results) && res.results.length === 0) {
          setIsLoadingPostalCode(false);
        } else if (res.results[`${zip_}`][0]) {
          setIsLoadingPostalCode(false);
        }
      } catch (e) {
        setIsLoadingPostalCode(false);
        console.log(e);
      }
    }
  }

  const isFreeWithSendcloud =
    freight === 1 && props?.userInfo?.country === "IT" && freightPrice?.price;

  const notHaveFreeSendCloud = props?.userInfo?.country !== "IT";

  const goToPageFour = () => {
    if (
      (weight <= 0 || weight <= 0 || width <= 0 || height <= 0) &&
      selectedCategory &&
      selectedCategory.id !== downloadableId &&
      selectedSubcategory &&
      selectedTypeProduct !== 2
    ) {
      showErrorToast({ detail: "dimensionsGreaterThanZero" });
      return;
    }

    if (!(weight * width * height >= 100) && selectedTypeProduct === 1) {
      showErrorToast({ detail: "minimunValueError" });
      return;
    }

    if (freight === 1 && !freightPrice?.price) {
      showErrorToast({ detail: "simulateLeastOneShippingValue" });
      return;
    }

    if (
      selectedCategory &&
      selectedCategory.id !== downloadableId &&
      selectedSubcategory &&
      selectedTypeProduct !== 2 &&
      freight < 1 &&
      isLoadingFreight === false
    ) {
      showErrorToast({ detail: "pleaseFillOutAll" });
      return;
    }

    if (!images) {
      showErrorToast({ detail: "pleaseUploadAtLeastOne" });
      return;
    }

    if (images?.length > 10) {
      showErrorToast({ detail: "youCanOnlyChooseUpTo5" });
      return;
    }

    if (percentExtraCoin === null) {
      showErrorToast({ detail: "populateCashback" });
      return;
    }

    if (percentExtraCoin < percentMin || percentExtraCoin > percentMax) {
      showErrorToast({ code: errorsNumbersForCashback[props.plan] });
      return;
    }

    if (promotionalPriceUnique >= priceUnique && hasDiscount) {
      showErrorToast({ detail: "promotionalPriceMustBeLessThan" });
      return;
    }

    if (
      selectedCategory &&
      selectedCategory.id !== downloadableId &&
      selectedSubcategory &&
      stock === 0
    ) {
      showErrorToast({ detail: "stockGreaterThanZero" });
      return;
    }

    if (isFreeWithSendcloud) {
      if (freightPrice?.price > priceUnique) {
        showErrorToast({ detail: "freightPriceGreaterThanPrice" });
        return;
      } else if (hasDiscount && freightPrice?.price > promotionalPriceUnique) {
        showErrorToast({ detail: "freightPriceGreaterThanPrice" });
        return;
      }
    }

    if (
      (title.length === 0 ||
        description.length === 0 ||
        (brands && brands.length > 0 && model.length === 0) ||
        (brands && brands.length > 0 && !brand) ||
        (types && types.length > 0 && !type) ||
        (genders && genders.length > 0 && !gender) ||
        (selectedCategory.id !== downloadableId && !productState) ||
        priceUnique === 0) &&
      selectedTypeProduct !== 3 &&
      selectedTypeProduct !== 2
    ) {
      showErrorToast({ detail: "pleaseFillOutAll" });
      return;
    }

    if (productState === "USED" && !productCondition) {
      showErrorToast({ detail: "pleaseFillOutAll" });
      return;
    }

    if (selectedCategory.id === downloadableId && (!downloadableProduct || !sampleProduct)) {
      showErrorToast({ detail: "pleaseFillOutAll" });
      return;
    }

    const measuresConditions =
      selectedCategory &&
      selectedCategory?.id !== downloadableId &&
      selectedSubcategory &&
      selectedTypeProduct !== 2 &&
      !selectedSubcategory?.service;

    const productObj = {
      title: title,
      description: description,
      model: brands && brands.length > 0 ? model : null,
      imageid1: images ? images[0] : null,
      imageid2: images ? images[1] : null,
      imageid3: images ? images[2] : null,
      percentExtraCoin: percentExtraCoin,
      priceUnique: priceUnique,
      promotionalPriceUnique: promotionalPriceUnique > 0 ? promotionalPriceUnique : null,
      productState: productState,
      productStatus: "UNPUBLISHED",
      subCategory: selectedSubcategory ? { id: selectedSubcategory.id } : null,
      user: { username: localStorage.getItem("__extraconomy_username") },
      brand: brand ? { id: brand.id } : null,
      type: type ? { id: type.id } : null,
      genderProduct: gender ? { id: gender.id } : null,
      conditionsUsedProduct: productCondition,
      sendBy: "SELLER",
      shippingOption:
        freight === 1
          ? "FREESENDCLOUD"
          : freight === 2
          ? "FREE"
          : freight === 3
          ? "PAID"
          : freight === 4
          ? "PICKUP"
          : null,
      shippingPrice: 0,
      downloadable: selectedTypeProduct === 3 ? true : false,
      downloadtype: selectedCategory.id === downloadableId ? downloadType : null,
      urldownload: null,
      urldownloadsample: null,
      cdnType: selectedCategory.id === downloadableId ? "CLOUDINARY" : null,
      downloadType: selectedCategory.id === downloadableId ? downloadType : null,
      service: selectedTypeProduct === 2 ? true : false,
      height: measuresConditions ? height : 0,
      width: measuresConditions ? width : 0,
      length: measuresConditions ? length : 0,
      weight: measuresConditions ? weight : 0,
    };

    setProduct(productObj);

    setPage(4);
  };

  useEffect(() => {
    if (productState === "NEW") setProductCondition(null);
  }, [productState]);

  useEffect(() => {
    async function fetchProducts(cancel) {
      try {
        setLoadingPermissionForCustomer(true);

        const res = await getUserInfoService.getProducts(
          localStorage.getItem("__extraconomy_token"),
          localStorage.getItem("__extraconomy_username")
        );
        if (cancel) return;

        if (res.messageCode !== 200001) {
          toast.current.show({
            severity: "error",
            summary: localeText("error"),
            detail: localeText("data").find((msg) => msg.code === res.messageCode).message,
            life: 6000,
          });
        } else {
          const qtdProductsActive = res?.result?.filter(
            (product) => product.status === "PUBLISHED"
          ).length;
          setCustomerHasPermission(qtdProductsActive < 5);
        }
      } catch (e) {
        console.log(e);
      } finally {
        setLoadingPermissionForCustomer(false);
      }
    }

    if (props.plan === "Customer") fetchProducts(); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.plan]);

  useEffect(() => {
    async function fetchStoreInfoAndSeeIfIsCreated() {
      try {
        if (props.plan === "Manager" || props.plan === "Seller") {
          setLoadingStore(true);
          const res = await getUserInfoService.getUserShop(
            localStorage.getItem("__extraconomy_username")
          );

          if (res.messageCode !== 200001) {
            showErrorToast({ code: res.messageCode });
            if (res.messageCode === 500000) console.log(res);
          } else {
            setCanPublish(!!res?.result?.shopConfiguration);
          }
        } else {
          setCanPublish(true);
        }
      } catch (e) {
        if (e.status === 401 || e.status === 403) {
          localStorage.removeItem("__extraconomy_token");
          localStorage.removeItem("__extraconomy_username");
          window.location.replace("/login");
        }
        console.log(e);
      } finally {
        setLoadingStore(false);
      }
    }

    fetchStoreInfoAndSeeIfIsCreated(); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props?.plan]);

  const base64ToFile = (base64String, fileName) => {
    // Separar o prefixo do conteúdo base64
    const arr = base64String.split(",");
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }

    // Criar e retornar o arquivo
    const file = new File([u8arr], fileName, { type: mime });

    // Gerar o objectURL
    const objectURL = URL.createObjectURL(file);
    file.objectURL = objectURL;
    return file;
  };

  const handleSaveImage = () => {
    setFalseTakePicture();
    if (images?.length > 10) {
      showErrorToast({ detail: "youCanOnlyChooseUpTo5" });
      fileUploadRef.current.setFiles(images);
      return;
    }

    const file = base64ToFile(imageSrc, "image.jpg");

    const isFileTooBig = Array.from([file]).some((file) => {
      if (file.size / 1024 / 1024 > 5) {
        showErrorToast({ detail: "fileSizeTooBig" });
        return true;
      }
      return false;
    });

    if (!isFileTooBig) {
      setImages((prevImages) => {
        return [...(prevImages || []), file];
      });
      fileUploadRef.current.getFiles().push(file);
      setImageSrc(null);
    }
  };

  const hasAddress =
    !!props?.userInfo?.city &&
    !!props?.userInfo?.state &&
    !!props?.userInfo?.country &&
    !!props?.userInfo?.postalCode &&
    !!props?.userInfo?.address;

  const basePrice = promotionalPriceUnique && hasDiscount ? promotionalPriceUnique : priceUnique;

  const cashbackValue =
    (promotionalPriceUnique && hasDiscount ? promotionalPriceUnique : priceUnique) *
    (percentExtraCoin / 100);

  const priceOfFEE =
    promotionalPriceUnique && hasDiscount
      ? promotionalPriceUnique * PLATFORM_PRODUCT_FEE
      : priceUnique * PLATFORM_PRODUCT_FEE;

  const finalValue = formatPrice(
    basePrice - priceOfFEE - cashbackValue - (freightPrice?.price ? freightPrice?.price : 0)
  );

  return (
    <>
      <Dialog
        header={localeText("shippingUnavailableWarning")}
        className="w-30rem m-2"
        visible={isVisibleAdressWarn}
        onHide={setNotVisibleAdressWarn}
        draggable={false}
        closable={false}
      >
        <>
          <p>{localeText("WeDoNotYetHaveShipping")}</p>
          <div className="flex justify-content-end">
            <Button onClick={setNotVisibleAdressWarn}>
              <div className="flex justify-content-center align-items-center gap-2">
                <p>{localeText("iKnow")}</p>
              </div>
            </Button>
          </div>
        </>
      </Dialog>

      <Dialog
        header={"Tirar foto do produto"}
        className="w-full m-2"
        style={{ maxHeight: "720px", maxWidth: "1280px" }}
        visible={valueTakePicture}
        onHide={setFalseTakePicture}
        draggable={false}
      >
        <div className="flex justify-content-center">
          {imageSrc ? (
            <div>
              <h3>{localeText("capturedImage")}:</h3>
              <img src={imageSrc} alt="Captured" className="camera" />
              <div className="mt-4 flex justify-content-end gap-2">
                <Button onClick={() => setImageSrc(null)}>{localeText("takeAnother")}</Button>
                <Button onClick={handleSaveImage}>{localeText("save")}</Button>
              </div>
            </div>
          ) : (
            <div>
              <Webcam
                audio={false}
                className="camera"
                height={720}
                width={1280}
                ref={webcamRef}
                screenshotFormat="image/jpeg"
                videoConstraints={videoConstraints}
              />
              <div className="mt-4 flex justify-content-end">
                <Button onClick={capture}>{localeText("takePicture")}</Button>
              </div>
            </div>
          )}
        </div>
      </Dialog>

      {isVisibleCostCalculator && (
        <CostCalculator
          onHide={handleHideModalCostCalculator}
          isVisible={isVisibleCostCalculator}
          userCurrency={currencyCode}
          selectedCategory={selectedCategory}
          selectedSubcategory={selectedSubcategory}
          selectedTypeProduct={selectedTypeProduct}
          notHaveFreeSendCloud={notHaveFreeSendCloud}
          percentMax={percentMax}
          percentMin={percentMin}
          userInfo={props?.userInfo}
          currencyCode={currencyCode}
          setProductPrice={setPriceUnique}
          setProductCashbackPercentage={setPercentExtracoin}
          setProductWeight={setWeight}
          setProductHeight={setHeight}
          setProductWidth={setWidth}
          setProductLength={setLength}
        />
      )}

      <Dialog
        header={localeText("registerPublishAndNotify")}
        className="w-30rem m-2"
        visible={isVisibleNotifyModal}
        onHide={() => {
          if (loadingRegisterPublish) return;
          setNotVisibleNotifyModal();
        }}
        draggable={false}
      >
        <div className="flex flex-row gap-2 h-full">
          <div className="flex flex-1 flex-column justify-content-between ">
            <p>
              {localeText("notifyCircleExplanationt1")} <strong>20 {localeText("credits")}</strong>{" "}
              {localeText("notifyCircleExplanationt2")}
            </p>
            <div className="flex justify-content-center">
              <Button
                onClick={() => registerProduct(true, false, true)}
                loading={loadingRegisterPublish}
                disabled={loadingRegisterPublish}
              >
                <div
                  className={`flex justify-content-center align-items-center gap-2 ${
                    loadingRegisterPublish ? "ml-2" : ""
                  }`}
                >
                  <p>{localeText("register")}</p>
                </div>
              </Button>
            </div>
          </div>
          <div className="border-right-2 border-gray-400" />
          <div className="flex flex-1 flex-column justify-content-between">
            <p>
              {localeText("notifyAllExplanation1")} <strong>50 {localeText("credits")}</strong>{" "}
              {localeText("notifyCircleExplanationt2")}
            </p>
            <div className="flex justify-content-center">
              <Button
                onClick={() => registerProduct(true, true, false)}
                loading={loadingRegisterPublish}
                disabled={loadingRegisterPublish}
              >
                <div
                  className={`flex justify-content-center align-items-center gap-2 ${
                    loadingRegisterPublish ? "ml-2" : ""
                  }`}
                >
                  <p>{localeText("register")}</p>
                </div>
              </Button>
            </div>
          </div>
        </div>
        <div></div>
      </Dialog>

      <div className="fixed bottom-0 right-0 z-5 mr-2" style={{ marginBottom: "90px" }}>
        <Button
          icon="pi pi-arrow-up"
          className="p-button p-button-rounded p-button-secondary"
          onClick={() => window.scrollTo(0, 0)}
        />
      </div>
      <div className="border-round" style={{ backgroundColor: "#46a748" }}>
        <h1 className="py-6 text-center text-0 lg:text-6xl md:text-6xl text-4xl">
          {localeText("addNewProduct")}
        </h1>
      </div>
      <div className="card border-1 border-300">
        {loadingCategories || loadingPermissionForCustomer || isLoadingStore ? (
          <div className="text-center">
            <i className="pi pi-spin pi-spinner text-8xl text-500 my-8"></i>
          </div>
        ) : (
          <>
            {props.plan === "Customer" && !customerHasPermission ? (
              <div className="flex flex-column align-items-center py-6">
                <p>{localeText("youHaveExceededThe5PublishedProducts")}</p>
                <p>{localeText("youHaveExceededThe5PublishedProductsExplanation")}</p>
              </div>
            ) : (
              <>
                {!hasPermissionRoles && (
                  <div className="text-center">
                    <i className="pi pi-lock text-8xl text-400 my-4"></i>
                    <h2 className="my-6">{localeText("planNotAllowed")}</h2>
                  </div>
                )}

                {!canPublish && (
                  <div className="flex flex-column align-items-center justify-content-center my-8">
                    <p>{localeText("youCannotPublishProductsYet")}</p>
                    <p>{localeText("firstCreateYourStore")}</p>
                  </div>
                )}

                {hasPermissionRoles && hasAddress && canPublish && (
                  <>
                    <Toast ref={toast} />

                    {/* Page 0 */}
                    {loadingCategories || isLoadinguseUserExtrabonus ? (
                      <div className="text-center">
                        <i className="pi pi-spin pi-spinner text-8xl text-500 my-8"></i>
                      </div>
                    ) : (
                      <div style={{ display: page !== 0 ? "none" : "block" }} className="mb-4">
                        <h3 className="my-4">{localeText("typeOfProduct")}</h3>
                        <p>
                          {localeText("freightService")}{" "}
                          {shippingIsAvailable
                            ? localeText("freightServiceAvaible")
                            : localeText("freightServiceUnavailable")}
                        </p>
                        <p className="text-600">{localeText("clickAndSelect")}</p>
                        <div className="flex mt-4">
                          <div className="progress-product-current"></div>
                          <div className="progress-product-unfulfilled"></div>
                          <div className="progress-product-unfulfilled"></div>
                          {(props.plan === "Manager" || props.plan === "Seller") && (
                            <div className="progress-product-unfulfilled"></div>
                          )}
                          <div className="progress-product-unfulfilled"></div>
                        </div>
                        <div className="flex justify-content-between my-4">
                          <div></div>
                          <Button
                            icon="pi pi-arrow-right"
                            label={localeText("next")}
                            iconPos="right"
                            onClick={() => {
                              if (!selectedTypeProduct)
                                showErrorToast({ detail: "pleaseSelectTypeProduct" });
                              else {
                                if (selectedTypeProduct === 3) {
                                  setSelectedCategory(
                                    categories.find((cat) => cat.id === downloadableId)
                                  );
                                  setSubcategories(
                                    categories.find((cat) => cat.id === downloadableId)
                                      .subCategories
                                  );
                                  setPage(2);
                                } else {
                                  setPage(1);
                                }
                              }
                            }}
                          />
                        </div>

                        <ul
                          className="flex align-items-center sm:justify-content-start justify-content-center gap-6 flex-wrap p-0"
                          id="create-product"
                        >
                          {listTypeProduct.map((type) => {
                            return (
                              <li
                                key={type.title}
                                id={`c${type.title}`}
                                className="p-2 list-none lg:w-11rem md:w-11rem w-9rem h-9rem flex flex-column gap-2 align-items-center justify-content-center text-center select-category lg:mr-4 md:mr-4 border-round"
                                style={
                                  selectedTypeProduct === type.type
                                    ? { backgroundColor: "#46a748", color: "#ffffff" }
                                    : { backgroundColor: "initial", color: "initial" }
                                }
                                onClick={() => {
                                  if (type.type !== 3)
                                    setSpecificCategories(
                                      categories.filter((cat) => cat.id !== downloadableId)
                                    );
                                  if (!selectedTypeProduct) {
                                    setSelectedTypeProduct(type.type);
                                    if (type.type === 3) {
                                      // ir direto para subcategoria
                                      setSelectedCategory(
                                        categories.find((cat) => cat.id === downloadableId)
                                      );
                                      setSubcategories(
                                        categories.find((cat) => cat.id === downloadableId)
                                          .subCategories
                                      );
                                      setPage(2);
                                    } else {
                                      setPage(1);
                                    }
                                  } else {
                                    setSelectedTypeProduct(type.type);

                                    if (type.type === 3) {
                                      // ir direto para subcategoria
                                      setSelectedCategory(
                                        categories.find((cat) => cat.id === downloadableId)
                                      );
                                      setSubcategories(
                                        categories.find((cat) => cat.id === downloadableId)
                                          .subCategories
                                      );
                                      setPage(2);
                                    } else {
                                      setPage(1);
                                    }
                                  }
                                }}
                              >
                                {!type.image ? (
                                  <div
                                    className="bg-cover bg-center md:w-8rem w-11rem border-round"
                                    style={{
                                      background: `url(https://media.istockphoto.com/vectors/thumbnail-image-vector-graphic-vector-id1147544807?k=20&m=1147544807&s=612x612&w=0&h=pBhz1dkwsCMq37Udtp9sfxbjaMl27JUapoyYpQm0anc=)`,
                                    }}
                                  ></div>
                                ) : (
                                  <AdvancedImage
                                    cldImg={cloudinaryInstance.image(type.image).format("webp")}
                                    className="border-round img-responsive-img"
                                  />
                                )}
                                <p>
                                  <span>{localeText(type.title)}</span>
                                </p>
                              </li>
                            );
                          })}
                        </ul>
                      </div>
                    )}

                    {/* Page 1 */}
                    {!loadingCategories && (
                      <div style={{ display: page !== 1 ? "none" : "block" }} className="mb-4">
                        <h3 className="my-4">{localeText("newProductcategories")}</h3>
                        <p>
                          {localeText("freightService")}{" "}
                          {shippingIsAvailable
                            ? localeText("freightServiceAvaible")
                            : localeText("freightServiceUnavailable")}
                        </p>
                        <p className="text-600">{localeText("clickAndSelect")}</p>
                        <div className="flex mt-4">
                          <div className="progress-product-current"></div>
                          <div className="progress-product-unfulfilled"></div>
                          <div className="progress-product-unfulfilled"></div>
                          {(props.plan === "Manager" || props.plan === "Seller") && (
                            <div className="progress-product-unfulfilled"></div>
                          )}
                          <div className="progress-product-unfulfilled"></div>
                        </div>
                        <div className="flex justify-content-between my-4">
                          <Button
                            icon="pi pi-arrow-left"
                            label={localeText("previous")}
                            iconPos="left"
                            onClick={() => setPage(0)}
                          />
                          <Button
                            icon="pi pi-arrow-right"
                            label={localeText("next")}
                            iconPos="right"
                            onClick={() => {
                              if (!selectedCategory)
                                showErrorToast({ detail: "pleaseSelectCategory" });
                              else setPage(2);
                            }}
                          />
                        </div>
                        <ul className="flex align-items-center sm:justify-content-start justify-content-center flex-wrap p-0 gap-6">
                          {specificCategories.map((category) => {
                            return (
                              <li
                                key={category.id}
                                id={`c${category.id}`}
                                className="p-2 list-none lg:w-11rem md:w-11rem w-9rem h-9rem flex flex-column gap-2 align-items-center justify-content-center text-center select-category lg:mr-4 md:mr-4 border-round"
                                style={
                                  selectedCategory?.id === category.id
                                    ? { backgroundColor: "#46a748", color: "#ffffff" }
                                    : { backgroundColor: "initial", color: "initial" }
                                }
                                onClick={() => {
                                  if (!selectedCategory) {
                                    setSelectedSubcategory(null);
                                    setSelectedCategory(category);
                                    setSubcategories(category.subCategories);
                                    setPage(2);
                                  } else {
                                    setSelectedSubcategory(null);
                                    setSelectedCategory(category);
                                    setSubcategories(category.subCategories);
                                    setPage(2);
                                  }
                                }}
                              >
                                {!category.imageid ? (
                                  <div
                                    className="bg-cover bg-center img-responsive-img border-round"
                                    style={{
                                      background: `url(https://media.istockphoto.com/vectors/thumbnail-image-vector-graphic-vector-id1147544807?k=20&m=1147544807&s=612x612&w=0&h=pBhz1dkwsCMq37Udtp9sfxbjaMl27JUapoyYpQm0anc=)`,
                                    }}
                                  ></div>
                                ) : (
                                  <AdvancedImage
                                    cldImg={cloudinaryInstance
                                      .image(category.imageid)
                                      .format("webp")}
                                    className="border-round img-responsive-img"
                                  />
                                )}

                                <div className="mb-2">
                                  {locale === "en" && <span>{category.descriptionEnglish}</span>}
                                  {locale === "it" && <span>{category.descriptionItalian}</span>}
                                  {locale === "pt" && <span>{category.descriptionPortuguese}</span>}
                                  {locale === "es" && <span>{category.descriptionSpanish}</span>}
                                </div>
                              </li>
                            );
                          })}
                        </ul>
                      </div>
                    )}

                    {/* Page 2 */}
                    <div style={{ display: page !== 2 ? "none" : "block" }} className="mb-4">
                      <h3 className="my-4">{localeText("subcategories")}</h3>
                      <p className="text-600">{localeText("clickAndSelect")}</p>
                      <div className="flex mt-4">
                        <div className="progress-product-fulfilled"></div>
                        <div className="progress-product-current"></div>
                        <div className="progress-product-unfulfilled"></div>
                        {(props.plan === "Manager" || props.plan === "Seller") && (
                          <div className="progress-product-unfulfilled"></div>
                        )}
                        <div className="progress-product-unfulfilled"></div>
                      </div>
                      <div className="flex justify-content-between my-4">
                        <Button
                          icon="pi pi-arrow-left"
                          label={localeText("previous")}
                          iconPos="left"
                          onClick={() => (selectedTypeProduct === 3 ? setPage(0) : setPage(1))}
                        />
                        {subcategories.length > 0 && (
                          <Button
                            icon="pi pi-arrow-right"
                            label={localeText("next")}
                            iconPos="right"
                            onClick={() => {
                              if (!selectedSubcategory && subcategories.length > 0)
                                showErrorToast({ detail: "pleaseSelectSubcategory" });
                              else setPage(3);
                            }}
                          />
                        )}
                      </div>
                      {subcategories.length > 0 ? (
                        <ul className="flex align-items-center sm:justify-content-start justify-content-center flex-wrap p-0 gap-6">
                          {subcategories.map((subcategory) => {
                            return (
                              <div
                                key={subcategory.id}
                                id={`s${subcategory.id}`}
                                className="p-2 list-none lg:w-11rem md:w-11rem w-9rem h-9rem flex flex-column gap-2 align-items-center justify-content-center text-center select-category lg:mr-4 md:mr-4 border-round"
                                style={
                                  selectedSubcategory?.id === subcategory.id
                                    ? { backgroundColor: "#46a748", color: "#ffffff" }
                                    : { backgroundColor: "initial", color: "initial" }
                                }
                                onClick={() => {
                                  if (!selectedSubcategory) {
                                    setSelectedSubcategory(subcategory);
                                    setNullProductInfo();

                                    fileUploadRef.current.clear();
                                    setPage(3);
                                  } else if (
                                    selectedSubcategory &&
                                    selectedSubcategory.id === subcategory.id
                                  ) {
                                    setPage(3);
                                  } else {
                                    setSelectedSubcategory(subcategory);
                                    setNullProductInfo();

                                    fileUploadRef.current.clear();
                                    setPage(3);
                                  }
                                }}
                              >
                                <li>
                                  <div className="flex justify-content-center">
                                    {!subcategory.imageid ? (
                                      <div
                                        className="bg-cover bg-center img-responsive-img border-round"
                                        style={{
                                          background: `url(https://media.istockphoto.com/vectors/thumbnail-image-vector-graphic-vector-id1147544807?k=20&m=1147544807&s=612x612&w=0&h=pBhz1dkwsCMq37Udtp9sfxbjaMl27JUapoyYpQm0anc=)`,
                                        }}
                                      ></div>
                                    ) : (
                                      <AdvancedImage
                                        cldImg={cloudinaryInstance
                                          .image(subcategory.imageid)
                                          .format("webp")}
                                        className=" border-round img-responsive-img"
                                      />
                                    )}
                                  </div>
                                </li>
                                <li className="mb-2">
                                  {locale === "en" && <span>{subcategory.descriptionEnglish}</span>}
                                  {locale === "it" && <span>{subcategory.descriptionItalian}</span>}
                                  {locale === "pt" && (
                                    <span>{subcategory.descriptionPortuguese}</span>
                                  )}
                                  {locale === "es" && <span>{subcategory.descriptionSpanish}</span>}
                                </li>
                              </div>
                            );
                          })}
                        </ul>
                      ) : (
                        <div className="text-center my-8">
                          <h4>{localeText("noSubcategories")}</h4>
                        </div>
                      )}
                    </div>

                    {/* Page 3 */}
                    <div style={{ display: page !== 3 ? "none" : "block" }} className="mb-4">
                      <h3 className="my-4">{localeText("productInfo")}</h3>
                      <p className="text-600">{localeText("productFields")}</p>
                      <div className="flex mt-4">
                        <div className="progress-product-fulfilled"></div>
                        <div className="progress-product-fulfilled"></div>
                        <div className="progress-product-current"></div>
                        {props.plan === "Manager" && (
                          <div className="progress-product-unfulfilled"></div>
                        )}
                        <div className="progress-product-unfulfilled"></div>
                      </div>
                      <div className="flex justify-content-between my-4">
                        <Button
                          icon="pi pi-arrow-left"
                          label={localeText("previous")}
                          iconPos="left"
                          onClick={() => {
                            setNullProductInfo();
                            setPage(2);
                          }}
                        />
                        <Button
                          icon="pi pi-arrow-right"
                          label={localeText("next")}
                          iconPos="right"
                          disabled={isLoadingFreight}
                          loading={isLoadingFreight}
                          onClick={goToPageFour}
                        />
                      </div>

                      <div className="grid mt-6 newproductContainer">
                        <div className="col-12">
                          <label htmlFor="title">{localeText("title")}</label>
                          <InputText
                            className="w-full my-2"
                            name="title"
                            value={title}
                            onChange={(e) => setTitle(e.target.value)}
                          />
                          <label htmlFor="description">{localeText("description")}</label>
                          <Editor
                            headerTemplate={<HeaderEditorTemplate />}
                            value={description}
                            className="my-2"
                            onTextChange={(e) => setDescription(DOMPurify.sanitize(e.htmlValue))}
                            style={{ height: "256px" }}
                          />
                          {brands &&
                            brands.length > 0 &&
                            selectedTypeProduct !== 2 &&
                            selectedTypeProduct !== 3 && (
                              <>
                                <label htmlFor="brand">{localeText("brand")}</label>

                                <Dropdown
                                  name="brand"
                                  className="w-full"
                                  value={brand}
                                  options={brands}
                                  onChange={(e) => setBrand(e.value)}
                                  placeholder={localeText("selectBrand")}
                                />
                              </>
                            )}
                        </div>
                        <div className="lg:col-4 md:col-4 col-12 w-full lg:w-4 md:w-4">
                          <div className="flex flex-row align-items-center gap-2">
                            <div className="flex flex-column">
                              <p className="font-bold text-lg p-0 m-0">
                                {localeText("finalPrice")}: {currencyCode}{" "}
                                {formatPrice(
                                  promotionalPriceUnique && hasDiscount
                                    ? promotionalPriceUnique +
                                        promotionalPriceUnique * PLATFORM_PRODUCT_FEE // plataformFEE
                                    : priceUnique + priceUnique * PLATFORM_PRODUCT_FEE // plataformFEE
                                )}
                              </p>
                            </div>

                            <Button
                              onClick={setVisibleCostCalculator}
                              label={localeText("priceCalculator")}
                              rounded
                              size="small"
                              className="text-xs"
                            />
                          </div>
                          <p className="text-600 p-0 m-0">
                            - {localeText("tax")} ({localeText("byBuyer")}) (5%): {currencyCode}{" "}
                            {formatPrice(priceOfFEE)}
                          </p>
                          <p className="text-600 p-0 m-0">
                            - {localeText("tax")} ({localeText("seller")}) (5%): {currencyCode}{" "}
                            {formatPrice(priceOfFEE)}
                          </p>
                          <p className="text-600 p-0 p-0 m-0">
                            - Cashback: {currencyCode} {formatPrice(cashbackValue)}
                          </p>
                          {freight === 1 && freightPrice && (
                            <div className="flex flex-wrap flex-row align-items-center mb-2">
                              <p className="text-600 m-0">
                                - {localeText("freight")}: {freightPrice?.currency}{" "}
                                {formatPrice(freightPrice?.price)}
                              </p>
                              <Tooltip target=".extracoin-tooltip" />
                              <i
                                className="pi pi-info-circle ml-1 extracoin-tooltip cursor-pointer text-600"
                                style={{ marginBottom: "2px" }}
                                data-pr-tooltip={`O valor do frete será descontado do valor do final do produto para ser repassado como grátis para o cliente.`}
                                data-pr-position="right"
                                data-pr-at="right+5 top"
                                data-pr-my="left center-2"
                                tooltipoptions={{ event: "focus" }}
                              ></i>
                            </div>
                          )}
                          <hr />
                          <p>
                            <strong>
                              {localeText("amountToReceive")}: {currencyCode} {finalValue}
                            </strong>
                          </p>

                          <div className="w-full">
                            <label htmlFor="priceUnique">{localeText("initialPrice")}:</label>
                            <InputNumber
                              mode="currency"
                              currency={currencyCode}
                              locale={localeISO}
                              className="w-full my-2"
                              name="priceUnique"
                              value={priceUnique}
                              onValueChange={(e) => setPriceUnique(e.value)}
                            />
                          </div>
                          <ul className="p-0 m-0 list-none">
                            <li>
                              <label htmlFor="promotionalPriceUnique">
                                {localeText("promotionalPrice")}
                              </label>
                              <InputNumber
                                mode="currency"
                                currency={currencyCode}
                                disabled={!hasDiscount}
                                locale={localeISO}
                                className="w-full my-2"
                                name="promotionalPriceUnique"
                                value={promotionalPriceUnique}
                                onValueChange={(e) => setPromotionalPriceUnique(e.value)}
                              />
                            </li>
                            <li className="mb-2">
                              <label htmlFor="hasdiscount">
                                <span className="text-700">{localeText("doYouWantDiscount")}</span>
                              </label>
                              <Checkbox
                                name="hasdiscount"
                                onChange={(e) => setHasDiscount(e.checked)}
                                checked={hasDiscount}
                                className="ml-2"
                              ></Checkbox>
                            </li>
                          </ul>
                          <label htmlFor="cashback">Cashback (%)</label>
                          <p className="text-xs mb-0">
                            {localeText("possibleCashbackAmountsIn")} (%)
                          </p>
                          <div className="flex flex-wrap gap-2">
                            {props.plan === "Customer" && (
                              <Tag
                                severity="warning"
                                value={`${localeText("yourProfile")} customer ${localeText(
                                  "canOfferACashbackOf"
                                )}  ${CUSTOMER_MAX_PERCENT_CASHBACK}%`}
                              ></Tag>
                            )}
                            {props.plan === "Seller" && (
                              <Tag
                                severity="warning"
                                value={`${localeText("yourProfile")} seller ${localeText(
                                  "canOfferACashbackOf"
                                )} ${SELLER_MAX_PERCENT_CASHBACK}%`}
                              ></Tag>
                            )}
                            {props.plan === "Manager" && (
                              <Tag
                                severity="warning"
                                value={`${localeText("yourProfile")} manager ${localeText(
                                  "canOfferACashbackOf"
                                )} ${MANAGER_MAX_PERCENT_CASHBACK}%`}
                              ></Tag>
                            )}
                            {props.plan === "Partner" && (
                              <Tag
                                severity="warning"
                                value={`${localeText("yourProfile")} partner ${localeText(
                                  "canOfferACashbackOf"
                                )} ${PARTNER_MAX_PERCENT_CASHBACK}%`}
                              ></Tag>
                            )}
                          </div>
                          <InputNumber
                            className="w-full my-2"
                            name="cashback"
                            min={percentMin}
                            max={percentMax}
                            value={percentExtraCoin}
                            onValueChange={(e) => setPercentExtracoin(e.value)}
                          />
                          {selectedCategory &&
                            selectedCategory.id !== downloadableId &&
                            selectedSubcategory && (
                              <>
                                <label htmlFor="stock">
                                  {localeText(selectedTypeProduct === 2 ? "quantity" : "stock")}
                                </label>
                                <InputNumber
                                  className="w-full my-2"
                                  name="stock"
                                  value={stock}
                                  onValueChange={(e) => setStock(e.value)}
                                />
                              </>
                            )}
                          <ul className="list-none p-0 m-0">
                            {selectedCategory &&
                              selectedCategory.id !== downloadableId &&
                              selectedSubcategory &&
                              selectedTypeProduct !== 2 && (
                                <>
                                  <li>
                                    <label htmlFor="productState">
                                      {localeText("productState")}
                                    </label>
                                  </li>
                                  <li className="mt-2">
                                    <Dropdown
                                      name="productState"
                                      className="w-full"
                                      value={productState}
                                      options={productStates}
                                      onChange={(e) => setProductState(e.value)}
                                      placeholder={localeText("selectProductState")}
                                    />
                                  </li>
                                  {productState === "USED" && (
                                    <>
                                      <li className="mt-2">
                                        <label htmlFor="productCondition">
                                          {localeText("condition")}
                                        </label>
                                      </li>
                                      <li className="mt-2">
                                        <Dropdown
                                          name="productCondition"
                                          className="w-full"
                                          value={productCondition}
                                          options={productConditions}
                                          onChange={(e) => setProductCondition(e.value)}
                                          placeholder={localeText("selectCondition")}
                                        />
                                      </li>
                                    </>
                                  )}
                                </>
                              )}

                            <ul className="p-0 m-0 mt-4 list-none">
                              <li className="mb-2">
                                <label htmlFor="hasdiscount">
                                  <span className="text-700">
                                    {localeText("wantToGivePercentageBeacuseShare")}
                                  </span>
                                </label>
                                <Checkbox
                                  name="hasdiscount"
                                  onChange={(e) => setHasComissionByShare(e.checked)}
                                  checked={hasComissionByShare}
                                  className="ml-2"
                                ></Checkbox>
                              </li>
                              {hasComissionByShare && (
                                <li>
                                  <label htmlFor="promotionalPriceUnique">
                                    {localeText("specifyThePercentageOfThePersonWhoShares")}{" "}
                                    0-100(%)
                                  </label>
                                  <InputNumber
                                    disabled={!hasComissionByShare}
                                    className="w-full my-2"
                                    name="promotionalPriceUnique"
                                    value={percentComissionByShare}
                                    onValueChange={(e) => setPercentComissionByShare(e.value)}
                                    min={0}
                                    max={100}
                                  />
                                </li>
                              )}
                            </ul>
                            {brands &&
                              brands.length > 0 &&
                              selectedTypeProduct !== 2 &&
                              selectedTypeProduct !== 3 && (
                                <>
                                  <li className="mt-2">
                                    <label htmlFor="model">{localeText("model")}</label>
                                    <InputText
                                      className="w-full mt-2"
                                      name="model"
                                      value={model}
                                      onChange={(e) => setModel(e.target.value)}
                                    />
                                  </li>
                                </>
                              )}
                            {types &&
                              types.length > 0 &&
                              selectedTypeProduct !== 2 &&
                              selectedTypeProduct !== 3 && (
                                <>
                                  <li className="mt-2">
                                    <label htmlFor="type">{localeText("type")}</label>
                                  </li>
                                  <li className="mt-2">
                                    <Dropdown
                                      name="type"
                                      className="w-full"
                                      value={type}
                                      options={types}
                                      onChange={(e) => setType(e.value)}
                                      placeholder={localeText("selectType")}
                                    />
                                  </li>
                                </>
                              )}
                            {genders && genders.length > 0 && selectedTypeProduct !== 2 && (
                              <>
                                <li className="mt-2">
                                  <label htmlFor="gender">{localeText("gender")}</label>
                                </li>
                                <li className="mt-2">
                                  <Dropdown
                                    name="gender"
                                    className="w-full"
                                    value={gender}
                                    options={genders}
                                    onChange={(e) => setGender(e.value)}
                                    placeholder={localeText("selectGender")}
                                  />
                                </li>
                              </>
                            )}
                          </ul>
                        </div>
                        <div className="lg:col-4 md:col-4 col-12 w-full lg:w-8 md:w-8">
                          <div className="flex justify-content-start gap-2 align-items-center">
                            {selectedCategory &&
                            selectedCategory.id === downloadableId &&
                            downloadType === "IMAGE" ? (
                              <label htmlFor="imagesproduct">
                                <span>{localeText("previewImages")}</span>
                              </label>
                            ) : (
                              <label htmlFor="imagesproduct">
                                <span>{localeText("productImages")}</span>
                              </label>
                            )}

                            <Button size="small" onClick={setTrueTakePicture}>
                              {localeText("takePicture")}
                            </Button>
                          </div>
                          <FileUpload
                            uploadOptions={uploadOptions}
                            chooseLabel={localeText("choose")}
                            cancelLabel={localeText("cancel")}
                            className="mt-2"
                            name="imagesproduct"
                            onSelect={(e) => {
                              // Verifica se o número de imagens excede 10
                              if (images?.length > 10) {
                                setImages((prevImages) => {
                                  return [...(prevImages || []), ...e.files];
                                });
                                showErrorToast({ detail: "youCanOnlyChooseUpTo5" });
                                fileUploadRef.current.setFiles(images);
                                // setImages(null);
                                // fileUploadRef.current.clear(); // Limpa o campo de upload
                                return;
                              }

                              // Verifica se algum arquivo ultrapassa o limite de 5MB
                              const isFileTooBig = Array.from(e.files).some((file) => {
                                if (file.size / 1024 / 1024 > 5) {
                                  showErrorToast({ detail: "fileSizeTooBig" });
                                  return true;
                                }
                                return false;
                              });

                              if (!isFileTooBig) {
                                setImages((prevImages) => {
                                  return [...(prevImages || []), ...e.files];
                                });
                              } else {
                                // Limpa o campo se o arquivo for grande demais
                                fileUploadRef.current.clear();
                              }
                            }}
                            onClear={() => {
                              setImages(null);
                            }}
                            onRemove={(e) => {
                              setImages((prev) => prev.filter((img) => img.name !== e.file.name));
                            }}
                            onError={() => {
                              fileUploadRef.current.clear();
                              setImages(null);
                            }}
                            onValidationFail={() => {
                              fileUploadRef.current.clear();
                              setImages(null);
                            }}
                            accept="image/*"
                            ref={fileUploadRef}
                            multiple
                            emptyTemplate={
                              <div className="text-center">
                                <i
                                  className="pi pi-upload text-400"
                                  style={{ fontSize: "3em" }}
                                ></i>
                                <h3 className="text-400">{localeText("dragImgs")}</h3>
                              </div>
                            }
                          />
                          <p className="text-600 mt-2">(max. 10 MB)</p>

                          {selectedCategory && selectedCategory.id === downloadableId && (
                            <>
                              <label htmlFor="downloadproduct">
                                <span className="text-xl font-bold">
                                  {localeText("uploadProductFile")}
                                </span>
                              </label>
                              <FileUpload
                                mode="basic"
                                name="downloadproduct"
                                ref={fileUploadDownloadable}
                                className="mt-2"
                                onSelect={(e) => {
                                  const file = e.files[0];

                                  if (file.size / 1024 / 1024 > 200) {
                                    setDownloadableProduct(null);
                                    fileUploadDownloadable.current.clear();
                                    showErrorToast({ detail: "fileSizeTooBig" });
                                    return false;
                                  }

                                  setDownloadableProduct(file);
                                }}
                                onClear={() => setDownloadableProduct(null)}
                                onRemove={() => {
                                  fileUploadDownloadable.current.clear();
                                  setDownloadableProduct(null);
                                }}
                                onError={() => {
                                  fileUploadDownloadable.current.clear();
                                  setDownloadableProduct(null);
                                }}
                                onValidationFail={() => {
                                  fileUploadDownloadable.current.clear();
                                  setDownloadableProduct(null);
                                }}
                                accept={
                                  downloadType === "AUDIO"
                                    ? "audio/*"
                                    : downloadType === "VIDEO"
                                    ? "video/*"
                                    : downloadType === "IMAGE"
                                    ? "image/*"
                                    : ".pdf, .txt, .doc, .docx, .epub, .mobi, .xlsx, .xls, .pptx, .ppt"
                                }
                              />
                              <p className="text-600 mt-2">(max. 200 MB)</p>

                              <label htmlFor="downloadproduct">
                                <span className="text-xl font-bold">
                                  {localeText("uploadProductSampleFile")}
                                </span>
                              </label>
                              <FileUpload
                                mode="basic"
                                name="downloadproduct"
                                ref={fileUploadSample}
                                className="mt-2"
                                onSelect={(e) => {
                                  const file = e.files[0];

                                  if (file.size / 1024 / 1024 > 200) {
                                    setSampleProduct(null);
                                    fileUploadSample.current.clear();
                                    showErrorToast({ detail: "fileSizeTooBig" });
                                    return false;
                                  }

                                  setSampleProduct(file);
                                }}
                                onClear={() => setSampleProduct(null)}
                                onRemove={() => {
                                  fileUploadSample.current.clear();
                                  setSampleProduct(null);
                                }}
                                onError={() => {
                                  fileUploadSample.current.clear();
                                  setSampleProduct(null);
                                }}
                                onValidationFail={() => {
                                  fileUploadSample.current.clear();
                                  setSampleProduct(null);
                                }}
                                accept={
                                  downloadType === "AUDIO"
                                    ? "audio/*"
                                    : downloadType === "VIDEO"
                                    ? "video/*"
                                    : downloadType === "IMAGE"
                                    ? "image/*"
                                    : ".pdf, .txt, .doc, .docx, .epub, .mobi, .xlsx, .xls, .pptx, .ppt"
                                }
                              />
                              <p className="text-600 mt-2">(max. 200 MB)</p>
                            </>
                          )}

                          {selectedCategory &&
                            selectedCategory.id !== downloadableId &&
                            selectedSubcategory &&
                            selectedTypeProduct !== 2 && (
                              <>
                                <ul className="list-none mx-0 mt-2 p-0">
                                  <li>
                                    <label htmlFor="height">{localeText("height")} (cm)</label>
                                  </li>
                                  <li>
                                    <InputNumber
                                      name="height"
                                      className="my-2 w-full"
                                      value={height}
                                      min={1}
                                      locale={localeISO}
                                      onValueChange={(e) => {
                                        if (e.value <= 0) {
                                          showErrorToast({ detail: "dimensionsGreaterThanZero" });
                                        } else setHeight(e.value);
                                      }}
                                      mode="decimal"
                                      minFractionDigits={2}
                                    />
                                  </li>
                                  <li>
                                    <label htmlFor="width">{localeText("width")} (cm)</label>
                                  </li>
                                  <li>
                                    <InputNumber
                                      name="width"
                                      className="my-2 w-full"
                                      value={width}
                                      min={1}
                                      locale={localeISO}
                                      onValueChange={(e) => {
                                        if (e.value <= 0) {
                                          showErrorToast({ detail: "dimensionsGreaterThanZero" });
                                        } else setWidth(e.value);
                                      }}
                                      mode="decimal"
                                      minFractionDigits={2}
                                    />
                                  </li>
                                  <li>
                                    <label htmlFor="length">{localeText("length")} (cm)</label>
                                  </li>
                                  <li>
                                    <InputNumber
                                      name="length"
                                      className="my-2 w-full"
                                      value={length}
                                      min={1}
                                      locale={localeISO}
                                      onValueChange={(e) => {
                                        if (e.value <= 0) {
                                          showErrorToast({ detail: "dimensionsGreaterThanZero" });
                                        } else setLength(e.value);
                                      }}
                                      mode="decimal"
                                      minFractionDigits={2}
                                    />
                                  </li>
                                  <li>
                                    <label htmlFor="weight">
                                      {localeText("chooseWeightRange")} (kg)
                                    </label>
                                  </li>
                                  <li className="mt-2 flex md:flex-row flex-column flex-wrap gap-3">
                                    {weightInputs.map((weightInput, i) => (
                                      <div key={i} className="flex align-items-center">
                                        <RadioButton
                                          inputId={`weight${i}`}
                                          name={weightInput.name}
                                          value={weightInput.value}
                                          disabled={isLoadingFreight}
                                          onChange={(e) => setWeight(e.value)}
                                          checked={weight === weightInput.value}
                                        />
                                        <label
                                          htmlFor={`weight${i}`}
                                          className="ml-2 cursor-pointer"
                                        >
                                          {weightInput.label}
                                        </label>
                                      </div>
                                    ))}
                                  </li>
                                  <li>
                                    <label htmlFor="freight" className="mt-2">
                                      {localeText("freight")}
                                    </label>
                                    <div className="mt-2 mb-2 flex md:flex-row flex-column flex-wrap gap-3">
                                      {freightInputs.map((freightInput, i) => {
                                        if (
                                          notHaveFreeSendCloud &&
                                          (freightInput.value === 1 ||
                                            freightInput.value === 3 ||
                                            freightInput.value === 4)
                                        )
                                          return null;
                                        return (
                                          <div key={i} className="flex align-items-center">
                                            <RadioButton
                                              inputId={`freight${i}`}
                                              name={freightInput.name}
                                              value={freightInput.value}
                                              onChange={(e) => {
                                                if (e.value !== 1) setFreightPrice(null);
                                                setFreight(e.value);
                                              }}
                                              checked={freight === freightInput.value}
                                            />
                                            <label
                                              htmlFor={`freight${i}`}
                                              className="ml-2 cursor-pointer capitalize"
                                            >
                                              {localeText(freightInput.label)}{" "}
                                              {freightInput.label === "free" &&
                                                `(${localeText("withOurFright")})`}
                                              {freightInput.label === "free2" &&
                                                `(${localeText("withoutOurFright")})`}
                                            </label>
                                            <Tooltip target=".extracoin-tooltip" />
                                            <i
                                              className="pi pi-info-circle ml-1 extracoin-tooltip cursor-pointer text-600"
                                              data-pr-tooltip={`${localeText(
                                                freightInput.explain
                                              )}`}
                                              data-pr-position="right"
                                              data-pr-at="right+5 top"
                                              data-pr-my="left center-2"
                                              tooltipoptions={{ event: "focus" }}
                                            ></i>
                                          </div>
                                        );
                                      })}
                                    </div>
                                    {freight === 1 && (
                                      <>
                                        <label htmlFor="postalCode">{localeText("zipCode")}</label>
                                        <span className="p-input-icon-right w-full">
                                          {isLoadingPostalCode && (
                                            <i className="pi pi-spin pi-spinner" />
                                          )}
                                          <InputText
                                            className="w-full my-2"
                                            name="postalCode"
                                            value={postalCode}
                                            onChange={(e) => setPostalCode(e.target.value)}
                                            onBlur={(e) => checkZipCode(e.target.value)}
                                            disabled={isLoadingPostalCode}
                                          />
                                        </span>
                                        <strong className="mt-1 mb-1 block">
                                          {localeText("enterZipCodeToSimulateEndCustomer")}
                                        </strong>
                                        <Button
                                          icon="pi pi-arrow-right"
                                          label={localeText("simulate")}
                                          iconPos="right"
                                          disabled={isLoadingFreight}
                                          loading={isLoadingFreight}
                                          onClick={getLocationId}
                                        />

                                        {isLoadingFreight ? (
                                          <div className="flex flex-row gap-2 align-items-center">
                                            <Loading
                                              classNameContainer={"my-3 text-left"}
                                              disableMargin
                                            />
                                            <p>{localeText("lookingTheBestShippingMethod")}</p>
                                          </div>
                                        ) : (
                                          <>
                                            {freightPrice && (
                                              <div className="mt-2">
                                                <strong>
                                                  {localeText("additionalShippingPriceProduct")}:{" "}
                                                  {freightPrice?.currency}{" "}
                                                  {formatPrice(freightPrice?.price)}
                                                </strong>
                                              </div>
                                            )}
                                          </>
                                        )}
                                      </>
                                    )}
                                  </li>
                                </ul>
                              </>
                            )}
                        </div>
                      </div>

                      <div className="flex justify-content-between my-4">
                        <Button
                          icon="pi pi-arrow-left"
                          label={localeText("previous")}
                          iconPos="left"
                          onClick={() => setPage(2)}
                        />
                        <Button
                          icon="pi pi-arrow-right"
                          label={localeText("next")}
                          iconPos="right"
                          disabled={isLoadingFreight}
                          loading={isLoadingFreight}
                          onClick={goToPageFour}
                        />
                      </div>
                    </div>

                    {/* Page 4 */}
                    {props.plan === "Manager" && (
                      <div style={{ display: page !== 4 ? "none" : "block" }} className="mb-4">
                        <h3 className="my-4">{localeText("productTechnicalInfo")}</h3>
                        <p className="text-600">{localeText("productTechnicalInfoExplanation")}</p>
                        <div className="flex mt-4">
                          <div className="progress-product-fulfilled"></div>
                          <div className="progress-product-fulfilled"></div>
                          <div className="progress-product-fulfilled"></div>
                          <div className="progress-product-current"></div>
                          <div className="progress-product-unfulfilled"></div>
                        </div>

                        <div className="flex justify-content-between my-4">
                          <Button
                            icon="pi pi-arrow-left"
                            label={localeText("previous")}
                            iconPos="left"
                            onClick={() => setPage(3)}
                          />
                          <Button
                            icon="pi pi-arrow-right"
                            label={localeText("next")}
                            iconPos="right"
                            onClick={() => setPage(5)}
                          />
                        </div>

                        <div className="grid mb-6">
                          <div className="col-6 p-1">
                            <p className="font-bold">{localeText("fieldName")}</p>
                          </div>
                          <div className="col-6 p-1">
                            <p className="font-bold">{localeText("fieldValue")}</p>
                          </div>
                          <div className="col-6 p-1">
                            <InputText
                              name="title"
                              className="mr-2 w-full"
                              value={techInfoKey1}
                              onChange={(e) => setTechInfoKey1(e.target.value)}
                            />
                          </div>
                          <div className="col-6 p-1">
                            <InputText
                              name="title"
                              className="w-full"
                              value={techInfoValue1}
                              onChange={(e) => setTechInfoValue1(e.target.value)}
                            />
                          </div>
                          <div className="col-6 p-1">
                            <InputText
                              name="title"
                              className="mr-2 w-full"
                              value={techInfoKey2}
                              onChange={(e) => setTechInfoKey2(e.target.value)}
                            />
                          </div>
                          <div className="col-6 p-1">
                            <InputText
                              name="title"
                              className="w-full"
                              value={techInfoValue2}
                              onChange={(e) => setTechInfoValue2(e.target.value)}
                            />
                          </div>
                          <div className="col-6 p-1">
                            <InputText
                              name="title"
                              className="mr-2 w-full"
                              value={techInfoKey3}
                              onChange={(e) => setTechInfoKey3(e.target.value)}
                            />
                          </div>
                          <div className="col-6 p-1">
                            <InputText
                              name="title"
                              className="w-full"
                              value={techInfoValue3}
                              onChange={(e) => setTechInfoValue3(e.target.value)}
                            />
                          </div>
                          <div className="col-6 p-1">
                            <InputText
                              name="title"
                              className="mr-2 w-full"
                              value={techInfoKey4}
                              onChange={(e) => setTechInfoKey4(e.target.value)}
                            />
                          </div>
                          <div className="col-6 p-1">
                            <InputText
                              name="title"
                              className="w-full"
                              value={techInfoValue4}
                              onChange={(e) => setTechInfoValue4(e.target.value)}
                            />
                          </div>
                          <div className="col-6 p-1">
                            <InputText
                              name="title"
                              className="mr-2 w-full"
                              value={techInfoKey5}
                              onChange={(e) => setTechInfoKey5(e.target.value)}
                            />
                          </div>
                          <div className="col-6 p-1">
                            <InputText
                              name="title"
                              className="w-full"
                              value={techInfoValue5}
                              onChange={(e) => setTechInfoValue5(e.target.value)}
                            />
                          </div>
                        </div>
                      </div>
                    )}

                    {/* Page 4 or 5 */}
                    <div
                      style={{
                        display: page !== (props.plan === "Manager" ? 5 : 4) ? "none" : "block",
                      }}
                      className="mb-4"
                    >
                      <h3 className="my-4">{localeText("productPreview")}</h3>
                      <p className="text-600">{localeText("pressRegisterOrPublish")}</p>
                      <p className="text-600">{localeText("pressRegisterAndPublish")}</p>
                      <p className="text-600">{localeText("pressRegisterPublishAndNotify")}</p>

                      <div className="flex mt-4">
                        <div className="progress-product-fulfilled"></div>
                        <div className="progress-product-fulfilled"></div>
                        <div className="progress-product-fulfilled"></div>
                        {props.plan === "Manager" && (
                          <div className="progress-product-fulfilled"></div>
                        )}
                        <div className="progress-product-current"></div>
                      </div>

                      {props.plan === "Manager" && (
                        <div className="my-4">
                          <p className="font-bold text-xl">{localeText("variationsExplanation")}</p>
                        </div>
                      )}

                      <div className="flex flex-wrap justify-content-between my-4">
                        <Button
                          icon="pi pi-arrow-left"
                          className="p-button-success font-bold m-1 w-full sm:w-auto"
                          label={localeText("previous")}
                          iconPos="left"
                          onClick={() => setPage(props.plan === "Manager" ? 4 : 3)}
                          disabled={loadingRegister || loadingRegisterPublish}
                        />
                        <div className="flex flex-wrap">
                          <Button
                            label={localeText("register")}
                            loading={loadingRegister || loadingRegisterPublish}
                            disabled={loadingRegisterPublish}
                            className="mr-2 w-full sm:w-auto m-1"
                            onClick={() => registerProduct(false)}
                          />
                          <Button
                            label={localeText("registerAndPublish")}
                            loading={loadingRegisterPublish}
                            disabled={loadingRegister}
                            className="p-button-warning font-bold w-full sm:w-auto m-1"
                            onClick={() => registerProduct(true)}
                          />
                          <Button
                            label={localeText("registerPublishAndNotify")}
                            loading={loadingRegisterPublish}
                            disabled={loadingRegister}
                            className="bg-blue-400 border-blue-400 hover:bg-blue-600 hover:border-blue-600 font-bold w-full sm:w-auto m-1"
                            onClick={setVisibleNotifyModal}
                          />
                        </div>
                      </div>

                      {product && selectedCategory && selectedSubcategory && images && (
                        <>
                          <div className="mt-6">
                            {locale === "en" && (
                              <span className="text-600">
                                {selectedCategory.descriptionEnglish}
                                {" >"}{" "}
                                {selectedSubcategory && selectedSubcategory.descriptionEnglish}
                              </span>
                            )}
                            {locale === "it" && (
                              <span className="text-600">
                                {selectedCategory.descriptionItalian}
                                {" >"}{" "}
                                {selectedSubcategory && selectedSubcategory.descriptionItalian}
                              </span>
                            )}
                            {locale === "pt" && (
                              <span className="text-600">
                                {selectedCategory.descriptionPortuguese}
                                {" >"}{" "}
                                {selectedSubcategory && selectedSubcategory.descriptionPortuguese}
                              </span>
                            )}
                            {locale === "es" && (
                              <span className="text-600">
                                {selectedCategory.descriptionSpanish}
                                {" >"}{" "}
                                {selectedSubcategory && selectedSubcategory.descriptionSpanish}
                              </span>
                            )}
                          </div>

                          <div className="lg:flex mx-0 mt-4">
                            <div className="lg:mr-2">
                              <ul className="my-0 p-0 list-none flex lg:block md:flex justify-content-center">
                                {images.map((image, index) => {
                                  return (
                                    <div key={`img${index}`}>
                                      <li
                                        className="flex justify-content-end mb-4 lg:mb-2 mx-1 lg:mx-0"
                                        onClick={() => {
                                          const deselectedImageElem = document.getElementById(
                                            `pi${currentImageIndex}`
                                          );
                                          deselectedImageElem.style.backgroundColor = "initial";
                                          deselectedImageElem.style.border = "1px solid #E0E0E0";

                                          const imageElem = document.getElementById(`pi${index}`);
                                          imageElem.style.backgroundColor = "#272360";
                                          imageElem.style.border = "1px solid #272360";

                                          setCurrentImageIndex(index);
                                        }}
                                      >
                                        <div
                                          style={{ border: "1px solid #E0E0E0" }}
                                          className="border-round p-2 product-thumbnail"
                                          id={`pi${index}`}
                                        >
                                          <div
                                            style={{ background: `url(${image.objectURL})` }}
                                            className="bg-center bg-cover h-4rem w-4rem"
                                          ></div>
                                        </div>
                                      </li>
                                    </div>
                                  );
                                })}
                              </ul>
                            </div>

                            <div className="outerDiv">
                              <div
                                style={{
                                  background: `url(${images[currentImageIndex].objectURL})`,
                                }}
                                className="border-round border-1 border-300 responsive-image mb-4 bg-cover bg-center"
                              ></div>
                            </div>

                            <div className="lg:ml-4 md:ml-4 ml-0">
                              <div className="flex align-items-center">
                                <h1
                                  className="lg:text-5xl md:text-4xl text-3xl"
                                  style={{ marginTop: "12px" }}
                                >
                                  <b>{product.title}</b>
                                </h1>
                                {selectedCategory && selectedCategory.id !== downloadableId ? (
                                  <>
                                    {selectedSubcategory && selectedTypeProduct !== 2 && (
                                      <span
                                        style={{
                                          backgroundColor:
                                            product.productState === "NEW" ? "#0288D1" : "#f7b005",
                                        }}
                                        className="text-0 p-1 text-xl border-round ml-2"
                                      >
                                        {product.productState === "NEW" &&
                                          localeText("new").toUpperCase()}
                                        {product.productState === "USED" &&
                                          localeText("used").toUpperCase()}
                                      </span>
                                    )}
                                  </>
                                ) : (
                                  <div className="flex">
                                    <i
                                      className="pi pi-download text-0 p-2 text-xl border-circle ml-2"
                                      style={{ backgroundColor: "#0288D1" }}
                                    ></i>
                                    <Tooltip target=".downloadable-tooltip" />
                                    <i
                                      className="pi pi-info-circle ml-1 downloadable-tooltip cursor-pointer text-600"
                                      data-pr-tooltip={`${localeText(
                                        "downloadableProductExplanation"
                                      )}`}
                                      data-pr-position="right"
                                      data-pr-at="right+5 top"
                                      data-pr-my="left center-2"
                                      tooltipoptions={{ event: "focus" }}
                                    ></i>
                                  </div>
                                )}
                              </div>

                              <div className="mt-4">
                                <ReactQuill
                                  className="react-quill-editor"
                                  value={DOMPurify.sanitize(product.description)}
                                  readOnly
                                  theme="bubble"
                                />
                              </div>

                              <div className="mb-4">
                                <p
                                  className={`font-semibold mb-0 text-primary ${
                                    promotionalPriceUnique
                                      ? "lg:text-xl text-base"
                                      : "lg:text-2xl text-xl"
                                  }`}
                                >
                                  {localeText("initialPrice")}:{" "}
                                  <span className={promotionalPriceUnique ? "line-through" : ""}>
                                    {props.currency}{" "}
                                    {formatPrice(
                                      priceUnique + priceUnique * PLATFORM_PRODUCT_FEE // + // plataformFEE
                                    )}
                                  </span>
                                </p>

                                {hasDiscount && promotionalPriceUnique && (
                                  <h4 className="flex align-items-center font-semibold my-0 lg:text-3xl text-xl text-primary">
                                    {localeText("promocionalPrice")}{" "}
                                    <span className="flex align-items-center font-semibold pl-1">
                                      {props?.currency}{" "}
                                      {formatPrice(
                                        promotionalPriceUnique +
                                          promotionalPriceUnique * PLATFORM_PRODUCT_FEE // plataformFEE
                                      )}
                                    </span>
                                  </h4>
                                )}

                                <p className="text-green-500 lg:text-xl text-base m-0">
                                  Cashback:{" "}
                                  <strong className="text-green-500 p-0">
                                    {props.currency}{" "}
                                    {formatPrice(
                                      (promotionalPriceUnique
                                        ? promotionalPriceUnique
                                        : priceUnique) *
                                        (percentExtraCoin / 100)
                                    )}
                                  </strong>
                                </p>
                              </div>

                              {selectedCategory &&
                                selectedCategory.id !== downloadableId &&
                                selectedSubcategory &&
                                selectedTypeProduct !== 2 && (
                                  <p className="text-700">
                                    {stock} {localeText("available")}
                                  </p>
                                )}
                              {selectedCategory &&
                              selectedCategory.id === downloadableId &&
                              sampleProduct ? (
                                <h5 className="my-4" style={{ color: "#0288d1" }}>
                                  {localeText("clickForASample")}
                                </h5>
                              ) : (
                                <>
                                  {selectedCategory &&
                                    selectedCategory.id !== downloadableId &&
                                    selectedSubcategory &&
                                    selectedTypeProduct !== 2 && (
                                      <p className="text-700">
                                        {localeText("shippingInfo")}: {localeText("bySeller")}
                                      </p>
                                    )}
                                </>
                              )}
                              <Button
                                label={localeText("addToCart")}
                                className="p-button p-button-warning text-xl mb-4"
                                icon="pi pi-shopping-cart"
                              />
                              {(brand || type || gender) && (
                                <ul className="card border-round surface-100 list-none p-2 m-0 mb-6 mt-4">
                                  {brand && (
                                    <>
                                      <li className="my-1">
                                        <hr className="my-1"></hr>
                                        <p className="m-0">
                                          <b>{localeText("brand")}</b>
                                        </p>
                                        {brand.description}
                                        <hr className="my-1"></hr>
                                      </li>
                                      <li className="mb-1">
                                        <p className="m-0">
                                          <b>{localeText("model")}</b>
                                        </p>
                                        {model}
                                        <hr className="my-1"></hr>
                                      </li>
                                    </>
                                  )}
                                  {type && (
                                    <li className="my-1">
                                      <p className="m-0">
                                        <b>{localeText("type")}</b>
                                      </p>
                                      {locale === "en" && <>{type.descriptionEnglish}</>}
                                      {locale === "it" && <>{type.descriptionItalian}</>}
                                      {locale === "pt" && <>{type.descriptionPortuguese}</>}
                                      {locale === "es" && <>{type.descriptionSpanish}</>}
                                      <hr className="my-1"></hr>
                                    </li>
                                  )}
                                  {gender && (
                                    <li className="my-1">
                                      <p className="m-0">
                                        <b>{localeText("gender")}</b>
                                      </p>
                                      {locale === "en" && <>{gender.descriptionEnglish}</>}
                                      {locale === "it" && <>{gender.descriptionItalian}</>}
                                      {locale === "pt" && <>{gender.descriptionPortuguese}</>}
                                      {locale === "es" && <>{gender.descriptionSpanish}</>}
                                      <hr className="my-1"></hr>
                                    </li>
                                  )}
                                </ul>
                              )}

                              {((techInfoKey1 && techInfoValue1) ||
                                (techInfoKey2 && techInfoValue2) ||
                                (techInfoKey3 && techInfoValue3) ||
                                (techInfoKey4 && techInfoValue4) ||
                                (techInfoKey5 && techInfoValue5)) && (
                                <>
                                  <p className="font-bold mt-4">
                                    {localeText("productTechnicalInfo")}
                                  </p>
                                  <div className="grid mb-4 lg:w-8">
                                    {techInfoKey1 && techInfoValue1 && (
                                      <>
                                        <div className="col-6 border-1 border-left-2 border-300">
                                          <p>{techInfoKey1}</p>
                                        </div>
                                        <div className="col-6 surface-100 border-1 border-right-2 border-300">
                                          <p>{techInfoValue1}</p>
                                        </div>
                                      </>
                                    )}
                                    {techInfoKey2 && techInfoValue2 && (
                                      <>
                                        <div className="col-6 border-1 border-left-2 border-300">
                                          <p>{techInfoKey2}</p>
                                        </div>
                                        <div className="col-6 surface-100 border-1 border-right-2 border-300">
                                          <p>{techInfoValue2}</p>
                                        </div>
                                      </>
                                    )}
                                    {techInfoKey3 && techInfoValue3 && (
                                      <>
                                        <div className="col-6 border-1 border-left-2 border-300">
                                          <p>{techInfoKey3}</p>
                                        </div>
                                        <div className="col-6 surface-100 border-1 border-right-2 border-300">
                                          <p>{techInfoValue3}</p>
                                        </div>
                                      </>
                                    )}
                                    {techInfoKey4 && techInfoValue4 && (
                                      <>
                                        <div className="col-6 border-1 border-left-2 border-300">
                                          <p>{techInfoKey4}</p>
                                        </div>
                                        <div className="col-6 surface-100 border-1 border-right-2 border-300">
                                          <p>{techInfoValue4}</p>
                                        </div>
                                      </>
                                    )}
                                    {techInfoKey5 && techInfoValue5 && (
                                      <>
                                        <div className="col-6 border-1 border-left-2 border-300">
                                          <p>{techInfoKey5}</p>
                                        </div>
                                        <div className="col-6 surface-100 border-1 border-right-2 border-300">
                                          <p>{techInfoValue5}</p>
                                        </div>
                                      </>
                                    )}
                                  </div>
                                </>
                              )}
                            </div>
                          </div>
                        </>
                      )}
                    </div>
                  </>
                )}

                {hasPermissionRoles && !hasAddress && (
                  <div className="text-center">
                    <i className="pi pi-lock text-8xl text-400 my-4"></i>
                    <h2 className="my-4">{localeText("notEnabled")}</h2>
                    <Link to="/dashboard-editprofile">
                      <Button label={localeText("editProfile")} />
                    </Link>
                  </div>
                )}
              </>
            )}
          </>
        )}
      </div>
    </>
  );
};

export default NewProduct;
